<template>
    <WizardTabWithSidebar
        sidebar-background-image="https://superangels.club/wp-content/uploads/2020/07/ESAC_2020_invest_connect_smart_mobility_72dpi_1600x1200_landscape_BACKGROUND_ONLY.jpg">
        <template #main>
            <WizardHeader :title="$t('account_settings_legal.risk_tolerance')" :icon="UsersIcon"></WizardHeader>
            <div class="px-4 py-3 sm:px-6">
                <LegalRiskToleranceForm v-model="formValues"></LegalRiskToleranceForm>
            </div>
        </template>
        <template #nextButton>
            <BaseButtonPrimary
                :loading="usePersonalAccountDataState().saving"
                :disabled="usePersonalAccountDataState().saving || formState.hasValidationErrors"
                size="lg"
                @click="submit()"
                >{{ $t('widget.save') }}
            </BaseButtonPrimary>
        </template>
        <template #previousButton>
            <BaseButtonMuted size="lg" @click="navigateToPreviousTab()">{{ $t('widget.back') }}</BaseButtonMuted>
        </template>

        <template #sidebar>
            <p class="pb-2 text-base font-bold text-gray-800">Overview of Risk Levels</p>
            <p class="pb-2 text-sm text-gray-800">
                <strong>Low</strong><br />The goal is relatively safe investment results. Exchange rate fluctuations and
                changes in interest rates are possible during the duration of the investment; low risk of capital loss.
            </p>
            <p class="pb-2 text-sm text-gray-800">
                <strong>Medium</strong><br />
                The aim is to achieve relatively safe investment results with a slightly increased risk. Price
                fluctuations and changes in interest rates are possible during the duration of the investment; medium
                risk of capital loss.
            </p>
            <p class="pb-2 text-sm text-gray-800">
                <strong>Advanced</strong><br />
                The aim is to generate higher returns while being aware of the higher risk. Interest rate, currency and
                thus higher exchange rate risks are possible; increased risk of capital loss.
            </p>
            <p class="pb-4 text-sm text-gray-800">
                <strong>High</strong><br />
                The aim is to generate very high yields, aware that they are facing very high risks. High price risks
                and losses from shares, interest rate and currency fluctuations or investments are possible; there is a
                willingness to risk large parts of the investment capital or the entire investment capital (for example,
                total loss in investments).
            </p>
            <p class="pb-2 text-sm text-gray-800">
                EXF Alpha, the syndicate fund and investment vehicle of the European Super Angels Club, is as a Venture
                Capital fund inherently considered a high-risk investment.
            </p>
        </template>
    </WizardTabWithSidebar>
</template>

<script setup lang="ts">
import WizardTabWithSidebar from '../../WizardTabWithSidebar.vue'
import WizardHeader from '../../WizardHeader.vue'
import BaseButtonPrimary from '../../../base/BaseButtonPrimary.vue'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import { RiskTolerance, usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { useLegalAccountFormState } from '../../../../utilities/account/useAccountFormLegal'
import { inject, onMounted, ref } from 'vue'
import { UsersIcon } from '@heroicons/vue/outline'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import LegalRiskToleranceForm from './form/LegalRiskToleranceForm.vue'

const formState = useLegalAccountFormState()
const { navigateToNextTab, navigateToPreviousTab, navigateToTab } = inject('navigation')

const formValues = ref(new RiskTolerance())

onMounted(() => {
    if (useLegalAccountDataState().legalProfile.compliance_profiles.esac) {
        formValues.value = useLegalAccountDataState().legalProfile.compliance_profiles.esac.risk_tolerance
    }
})

async function submit() {
    const { valid } = await formState.currentForm.validate()
    if (valid) {
        useLegalAccountDataState().legalProfile.compliance_profiles.esac.risk_tolerance = formValues.value
        await formState.submit()
        navigateToNextTab()
    }
}
</script>

<style scoped></style>
